// Single chat message bubble, sent or received.

import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Linkify from 'linkify-react';
import { Drafty, Tinode } from '../tinode/tinode';

import Attachment from './attachment.jsx';
import LetterTile from './letter-tile.jsx';
import ReceivedMarker from './received-marker.jsx'

import { fullFormatter } from '../lib/formatters.js';
import { sanitizeUrl } from '../lib/utils.js';
import { IconHeart, IconNoHeart } from '../icons/emoticons';
import { NODE_SUBTYPE_MESSAGE, REACT_MESSAGE_TYPE, MESSAGE_EMOTIONS_ID } from '../tinode/constants';
import { TOPIC_ME } from '../tinode/config'
import PreviewLink from './preview-link.jsx';
import lodash from 'lodash'

import Helpers from '../lib/helpers';
import MessageContent from '../tinode/message-content'

const messages = defineMessages({
	cannot_message_yourself: {
		id: 'cannot_message_yourself',
		defaultMessage: 'You cannot send messages to yourself',
		description: 'You cannot send messages to yourself'
	}
});

class BaseChatMessage extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			progress: 0
		};

		if (props.uploader) {
			props.uploader.onProgress = this.handleProgress.bind(this);
		}

		this.handleExpandImage = this.handleExpandImage.bind(this);
		this.handlePlayVideo = this.handlePlayVideo.bind(this);
		this.handleFormButtonClick = this.handleFormButtonClick.bind(this);
		this.handleContextClick = this.handleContextClick.bind(this);
		this.handleCancelUpload = this.handleCancelUpload.bind(this);
		this.handleQuoteClick = this.handleQuoteClick.bind(this);
		this.handleEmotion = this.handleEmotion.bind(this);
		this.getMotion = this.getMotion.bind(this);
		this.renderListMotions = this.renderListMotions.bind(this);
		this.handleClickProfileInfo = this.handleClickProfileInfo.bind(this);
		this.renderListMotionReact = this.renderListMotionReact.bind(this);
		this.handleClickReact = this.handleClickReact.bind(this);
		this.handleClickTagAction = this.handleClickTagAction.bind(this);
		this.formatterContext = {
			formatMessage: props.intl.formatMessage.bind(props.intl),
			viewportWidth: props.viewportWidth,
			authorizeURL: props.tinode.authorizeURL.bind(props.tinode),

			onImagePreview: this.handleExpandImage,
			onVideoPreview: this.handlePlayVideo,
			onFormButtonClick: this.handleFormButtonClick,
			onQuoteClick: this.handleQuoteClick
		};

		this.getSideClass = this.getSideClass.bind(this);
		this.isShowReact = this.isShowReact.bind(this);
	}

	handleExpandImage(e) {
		e.preventDefault();
		this.props.onExpandMedia({
			url: e.target.src,
			filename: e.target.dataset.name,
			width: e.target.dataset.width,
			height: e.target.dataset.height,
			size: e.target.dataset.size,
			type: e.target.dataset.mime,
			msgInfo: this.props.msg
		});
	}

	handlePlayVideo(e) {
		e.preventDefault();
		this.props.onExpandMedia({
			video: true,
			url: e.target.dataset.src,
			preview: e.target.src,
			filename: e.target.dataset.name,
			width: e.target.dataset.width,
			height: e.target.dataset.height,
			duration: e.target.dataset.duration,
			size: e.target.dataset.size,
			type: e.target.dataset.mime
		});
	}

	handleFormButtonClick(e) {
		e.preventDefault();
		const data = {
			seq: this.props.seq
		};
		data.resp = {};
		if (e.target.dataset.name) {
			data.resp[e.target.dataset.name] = e.target.dataset.val ? e.target.dataset.val :
				e.target.dataset.val === undefined ? 1 : '' + e.target.dataset.val;
		}
		if (e.target.dataset.act == 'url') {
			data.ref = sanitizeUrl(e.target.dataset.ref) || 'about:blank';
		}
		const text = e.target.dataset.title || 'unknown';
		this.props.onFormResponse(e.target.dataset.act, text, data);
	}

	handleContextClick(e) {
		window.logger("handleContextClick|", this.props.msg)
		console.log(this.props.msg)
		if (event.which == 3 && this.props.showContextMenu) {
			e.preventDefault();
			e.stopPropagation();
			let menuItems = [];

			// Tin nhắn thông báo, thu hồi không hiển thị chuột phải
			if (this.props.msg.subtype === NODE_SUBTYPE_MESSAGE.NOTIFY || this.props.msg.subtype === NODE_SUBTYPE_MESSAGE.RECALL) {
				return
			}

			if (!this.props.isOfficial) {
				if (this.props.received == Tinode.MESSAGE_STATUS_FAILED) {
					menuItems.push('menu_item_send_retry');
				}
				if (this.props.userIsWriter && this.props.received > Tinode.MESSAGE_STATUS_FATAL) {
					if (this.props.msg.subtype !== NODE_SUBTYPE_MESSAGE.CONTACT && this.props.msg.subtype !== NODE_SUBTYPE_MESSAGE.VOICE_STICKER
						&& this.props.msg.subtype !== NODE_SUBTYPE_MESSAGE.AUDIO) {
						menuItems.push('menu_item_reply');
					}

					if (!this.props.response) {
						let immutable = false;
						Drafty.entities(this.props.content, (_0, _1, tp) => {
							immutable = ['AU', 'EX', 'FM', 'IM', 'VC', 'VD'].includes(tp);
							return immutable;
						});
						if (!immutable) {
							Drafty.styles(this.props.content, tp => {
								immutable = ['QQ'].includes(tp);
								return immutable;
							});
						}
					}
				}
				menuItems.push('menu_item_forward');
				if (this.props.msg.subtype === NODE_SUBTYPE_MESSAGE.TEXT) {
					menuItems.push('menu_item_copy');
					menuItems.push('menu_item_save')
				}

				if (this.props.msg.subtype === NODE_SUBTYPE_MESSAGE.IMAGE) {
					menuItems.push('menu_item_copy');
				}

				if (this.props.isGroup) {
					const { content } = this.props;
					if (typeof content === 'string' || content.replyBody === 'string') {
						menuItems.push('menu_item_pin');
					}
					if (this.props.isOwnMessages) {
						menuItems.push('message_seen');
					}
				}

				if (this.props.isVote) {
					menuItems = [];
				}
			}


			this.props.showContextMenu({
				msg: this.props.msg,
				seq: this.props.seq,
				replace: this.props.edited ? parseInt(this.props.edited.split(':')[1]) : 0,
				content: this.props.content,
				userFrom: this.props.userFrom,
				userName: this.props.userName,
				y: e.pageY,
				x: e.pageX,
				pickReply: this.props.pickReply,
				editMessage: this.props.editMessage,
				saveMessage: this.props.saveMessage,
			}, menuItems);
		}
	}

	handleProgress(ratio) {
		this.setState({ progress: ratio });
	}

	handleCancelUpload() {
		this.props.onCancelUpload(this.props.seq, this.props.uploader);
	}

	handleQuoteClick(e) {
		e.preventDefault();
		e.stopPropagation();
		const replyToSeq = this.props.replyToSeq;
		if (replyToSeq) {
			this.props.onQuoteClick(replyToSeq);
		}
	}

	renderEmotions() {
		let element = [];
		const { myMotionId } = this.props;
		for (const emotion of Tinode.MESSAGE_EMOTIONS) {
			element.push(<div onClick={() => this.handleEmotion(emotion.id)} key={emotion.id} checked={myMotionId?.motionId == emotion.id}>{emotion.icon}</div>)
		}

		if (this.getMotion()) {
			element.push(<div onClick={() => this.handleEmotion(myMotionId?.motionId, REACT_MESSAGE_TYPE.REMOVE)} key={0}><IconNoHeart /></div>)
		}
		return element;
	}

	renderListMotions() {
		let element = [];
		const { motions } = this.props;
		if (motions && typeof motions == 'object' && motions.length > 0) {
			for (const motion of motions) {
				element.push(<div key={motion.value}>{Tinode.MESSAGE_EMOTIONS.find(item => item.id === motion.motionId).icon}</div>);
			}
			element.push(<div className='count-motion'>{motions.reduce((a, v) => a + v.value, 0)}</div>);
		}

		return element;
	}

	handleEmotion(mId, type = REACT_MESSAGE_TYPE.ADD) {
		if (this.props.msg && this.props.tinode) {
			this.props.tinode.sendMotions(this.props.msg, mId, type)
		}
	}

	getMotion() {
		try {
			return Tinode.MESSAGE_EMOTIONS.find(item => item.id == this.props.myMotionId?.motionId).icon;
		} catch (error) {

		}
		return false
	}

	handleClickProfileInfo() {
		const topic = this.props.userFrom
		this.props.onShowDialog(Tinode.DIALOG_TYPE.PERSONAL_INFORMATION, { topicProfile: topic });
	}

	handleClickTagAction(topicId) {
		const topic = this.props.tinode.getTopicByName(topicId, {
			isCreateWhenNotExist: true
		})
		if (topic.name !== TOPIC_ME) {
			// this.props.onTopicSelected(topicId)
			this.props.onShowDialog(Tinode.DIALOG_TYPE.PERSONAL_INFORMATION, { topicProfile: topicId })
		} else {
			const { formatMessage } = this.props.intl;
			Helpers.showErrorToasts(formatMessage(messages.cannot_message_yourself))
		}
	}

	renderContent(content, data) {
		data.handleClickTagAction = this.handleClickTagAction
		return MessageContent.renderContent(this.props.tinode, content, data)
	}

	renderListMotionReact() {
		const filterReact = this.props.motions.filter((v, i, s) => {
			return s.findIndex(ss => ss.motionId === v.motionId) === i;
		});
		return filterReact.slice(0, 4).map((motion, key) => {
			return (
				<div key={key}>{Tinode.MESSAGE_EMOTIONS.find(item => item.id == motion.motionId)?.icon}</div>
			)
		})

	}

	handleClickReact() {
		this.props.onShowDialog(Tinode.DIALOG_TYPE.SHOW_REACT, { motions: this.props.motions });
	}

	getSideClass() {
		const { isVote, isNotify, response } = this.props;
		let classPosition = response ? 'left' : 'right';
		if (isNotify) {
			classPosition = 'notify';
		} else if (isVote) {
			classPosition = 'vote'
		}
		return this.props.sequence + ' ' + classPosition;
	}

	isShowReact() {
		const { motions } = this.props;
		try {
			return (motions && typeof motions === 'object' && motions.length > 0);
		} catch (error) {
			return false
		}
	}

	onShowReact(e) {
		e.target.classList.add('active');
		setTimeout(() => {
			e.target.classList.remove('active');
		}, 300);
	}

	render() {
		const sideClass = this.getSideClass();
		let bubbleClass = (this.props.sequence == 'single' || this.props.sequence == 'last') ? 'bubble tip' : 'bubble';
		if (this.props.msg.subtype === NODE_SUBTYPE_MESSAGE.VOICE_STICKER) {
			bubbleClass += ' voicesticker'
		}
		const avatar = this.props.userAvatar || true;
		const fullDisplay = (this.props.isGroup && this.props.response &&
			(this.props.sequence == 'single' || this.props.sequence == 'first'));

		let content = this.props.content;
		const { tags, previewLink, motions, tagAll } = this.props
		const attachments = [];
		if (this.props.mimeType == Drafty.getContentType() && Drafty.isValid(content)) {
			Drafty.attachments(content, (att, i) => {
				attachments.push(<Attachment
					tinode={this.props.tinode}
					downloadUrl={Drafty.getDownloadUrl(att)}
					filename={att.name}
					uploading={Drafty.isProcessing(att)}
					mimetype={att.mime}
					size={Drafty.getEntitySize(att)}
					progress={this.state.progress}
					onCancelUpload={this.handleCancelUpload}
					onError={this.props.onError}
					key={i} />);
			}, this);
			const props = {
				tinode: this.props.tinode,
				onCreateTopic: this.props.onCreateTopic,
				topic: this.props.topic,
				onShowDialog: this.props.onShowDialog,
				pollMsg: this.props.pollMsg,
				onTopicSelected: this.props.onTopicSelected
			}
			const tree = Drafty.format(content, fullFormatter, this.formatterContext, props);

			if (tags && Array.isArray(tags) && tags.length > 0) {
				try {
					const len = tree.length
					const tagResult = this.renderContent(tree[len - 1][0], { tags, tagAll })
					tree[len - 1] = tagResult
				} catch (error) {
					console.error(error)
				}
			}
			
			if (lodash.has(this.props.msg, 'content.replyMsg')) {
				if (lodash.has(this.props.msg, 'content.replyMsg.bodyTag')) {
					try {
						const replyMsg = tree[0]
						if (replyMsg && Array.isArray(replyMsg?.props?.children)) {
							const children = replyMsg.props.children
							if (children.length > 1) {
								children[2][0] = this.renderContent(children[2][0], { tags: this.props.msg.content.replyMsg.bodyTag, clickAction: false, tagAll: this.props.msg.content.replyMsg.bodyTagAll })
							}
						}
					} catch (e) { }
				}


				try {
					const len = tree.length
					if (len > 0) {
						if (Array.isArray(tree[0]?.props?.children)) {
							if (tree[0]?.props?.children.length > 2 && typeof tree[0].props.children[2][0] === 'string') {
								const contentReplyFormat = this.renderContent(tree[0].props.children[2][0], {})
								tree[0].props.children[2][0] = contentReplyFormat
							}	
						}
					}
				} catch (error) {
					console.error(error)
				}

				try {
					const len = tree.length
					if (len > 0) {
						if (typeof tree[1][0] === 'string') {
							const contentFormat = this.renderContent(tree[1][0], {})
							tree[1][0] = contentFormat
						}
					}
				} catch (error) {
					console.error(error)
				}
			}


			try {
				if (typeof tree[tree.length - 1][0] === 'string') {
					tree[tree.length - 1][0] = <Linkify options={{ target: '_blank' }}>
						{tree[tree.length - 1][0]}
					</Linkify>
				}
			} catch (error) { }

			content = React.createElement(React.Fragment, null, tree);
		} else if (typeof content != 'string') {
			content = <><i className="material-icons gray">warning_amber</i> <i className="gray">
				<FormattedMessage id="invalid_content"
					defaultMessage="invalid content" description="Shown when the message is unreadable" /></i></>
		} else {
			const msgTags = Array.isArray(tags) && tags.length > 0 ? tags : []
			content = React.createElement(React.Fragment, null, this.renderContent(content, { tags: msgTags, tagAll }));
		}

		if (typeof previewLink === 'object') {
			content = <PreviewLink
				content={content}
				description={previewLink.description}
				itemName={previewLink.item_name}
				imgUrl={previewLink.img_url}
				url={previewLink.url}
				site={previewLink.site}
			/>
		}


		return (
			<li ref={this.props.innerRef} className={sideClass}>
				<div style={{ marginBottom: (motions && typeof motions === 'object' && motions.length > 0) ? 15 : 0 }}>
					{this.props.isGroup && this.props.response && fullDisplay ?
						<div className="custom-show-user-gr">
							<div className="avatar-box" onClick={this.handleClickProfileInfo}>
								<LetterTile
									tinode={this.props.tinode}
									topic={this.props.userFrom}
									title={this.props.userName}
									avatar={avatar} />
							</div>
							<div className="author">
								{this.props.userName ||
									<i><FormattedMessage id="user_not_found" defaultMessage="Not found"
										description="In place of a user's full name when the user is not found." /></i>
								}
							</div>
						</div> :
						null}
					<div className={bubbleClass} onMouseDown={this.handleContextClick}>
						<div className="content-meta">
							<div className="message-content">
								{content}
								{attachments}
							</div>
							{this.props.timestamp ?
								<ReceivedMarker
									edited={this.props.edited}
									timestamp={this.props.timestamp}
									received={this.props.received} />
								: null}
							{this.props?.isSimplify !== true && !this.props.isVote && this.props.msg.subtype !== NODE_SUBTYPE_MESSAGE.RECALL &&
								<div className="box-hover" disabled={!this.isShowReact()} onMouseLeave={this.onShowReact}>
									<div className="feeling" >
										<div onClick={() => this.handleEmotion(MESSAGE_EMOTIONS_ID.HEART_RED)} className={'heart'}>
											{!this.getMotion() ? <IconHeart /> : this.getMotion()}
										</div>
										<div className="emotion">
											{this.renderEmotions()}
										</div>
									</div>
								</div>
							}

						</div>
						{/* {this.props.showContextMenu ?
              <span className="menuTrigger">
                <a href="#" onClick={this.handleContextClick}>
                  <i className="material-icons">expand_more</i>
                </a>
              </span> : null
            } */}
						{motions && typeof motions === 'object' && motions.length > 0 ?
							<div className="list-motion" onClick={this.handleClickReact}>
								{this.renderListMotionReact()}
								{<div className='count-motion'>{motions.length}</div>}
							</div> :
							null}
					</div>
				</div>
			</li>
		);
	}
};

const IntlChatMessage = injectIntl(BaseChatMessage);
const ChatMessage = React.forwardRef((props, ref) => <IntlChatMessage innerRef={ref} {...props} />);

export default ChatMessage;
